import { render } from "./EditClaimView.vue?vue&type=template&id=4bbf977a"
import script from "./EditClaimView.vue?vue&type=script&lang=js"
export * from "./EditClaimView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__